import React from 'react';

import {
  ButtonGroup,
  type ButtonGroupProps,
} from '@frontend/components/src/components/forms/button/ButtonGroup';

export const AlertButtonWrapper = React.forwardRef<
  HTMLDivElement,
  ButtonGroupProps
>((props, ref) => <ButtonGroup ref={ref} size="md" {...props} />);

AlertButtonWrapper.displayName = 'AlertButtonWrapper';
